import { Stack, Typography, TypographyOwnProps } from '@mui/material';
import { Appointment, GeneralRequest } from '../../interfaces';
import { QueueAppointment } from '../../types/queue';
import { isMinor } from '../../utils/global/helper';
import Badge from '../global/Badge';
import { getCustomerDetails } from '../../helpers/appointments';
import { WaiverRequestWithCustomerAndEvents } from '../../types/waivers';
import { getWaiverCustomerDetails } from '../../helpers/waivers';
import { getFullName } from '../../helpers/global';

type Props = {
  typographyVariant?: TypographyOwnProps['variant'];
  minorForAppointment?: boolean;
} & (
  | {
      appointment: Appointment | GeneralRequest | QueueAppointment;
    }
  | { waiverRequest: WaiverRequestWithCustomerAndEvents }
);

export const EXTRA_WIDTH = 60;

function CustomerNameAge({ typographyVariant = 'body1', ...props }: Props) {
  const { dob, firstName, lastName } =
    'appointment' in props
      ? getCustomerDetails(props.appointment)
      : getWaiverCustomerDetails(props.waiverRequest);
  const appointment =
    'appointment' in props
      ? props.appointment
      : props.waiverRequest.appointment;
  const startDateTime =
    'startDateTime' in appointment && props.minorForAppointment
      ? appointment.startDateTime
      : undefined;

  const fullName = getFullName({ firstName, lastName });
  const isCustomerMinor = isMinor(dob, startDateTime);

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant={typographyVariant} className="ellipsis">
        {fullName}
      </Typography>
      {isCustomerMinor && <Badge text="Minor" colorScheme="warning" rounded />}
    </Stack>
  );
}

export default CustomerNameAge;
